import React from 'react';
import AccommodationPriceCell from './AccommodationPriceCell';

export default function SupplementsGrid({
  categories,
  rooms,
  period,
  t,
  isReadOnly = false,
}) {
  // Find the price index for a given category, room, and optional periodId
  const periodId = period.id;
  const findPriceIndex = (category, roomIndex) => {
    if (!category.prices) return -1;
    // Try exact match (roomIndex + periodId)
    let idx = category.prices.findIndex(
      (p) =>
        p.roomIndex === roomIndex &&
        (periodId ? p.periodId === periodId : !p.periodId),
    );
    // Fallback: match by roomIndex only (legacy prices without periodId)
    if (idx === -1 && periodId) {
      idx = category.prices.findIndex(
        (p) => p.roomIndex === roomIndex && !p.periodId,
      );
    }
    return idx;
  };

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full table-auto">
        <thead>
          <tr className="bg-gray-50">
            <th className="text-left py-3 px-4 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-200 whitespace-nowrap">
              {t('accommodation.roomType', 'Room type')}
            </th>
            {categories.map((category, catIndex) => (
              <th
                key={catIndex}
                className="text-left py-3 px-4 text-xs font-semibold uppercase tracking-wider border-b border-gray-200 text-gray-500 whitespace-nowrap"
              >
                {category.name || `Category ${catIndex + 1}`}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {rooms.map((room, roomIndex) => (
            <tr
              key={roomIndex}
              className="hover:bg-gray-50/50 transition-colors"
            >
              <td className="py-3 px-4 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <div className="flex-shrink-0 w-6 h-6 rounded bg-gray-100 flex items-center justify-center">
                    <i className="fa fa-bed text-gray-400 text-[10px]" />
                  </div>
                  <div>
                    <div className="font-medium text-sm text-gray-800">
                      {room.name}
                    </div>
                    <div className="text-xs text-gray-400">
                      {room.paxCount} {t('accommodation.pax', 'pax')}
                    </div>
                  </div>
                </div>
              </td>
              {categories.map((category, catIndex) => {
                const priceIndex = findPriceIndex(category, roomIndex);
                const basePrice =
                  (period.adultPax ?? []).find(
                    (a) =>
                      a.paxRange[0] <= room.paxCount &&
                      room.paxCount <= a.paxRange[1],
                  )?.price ??
                  period.price ??
                  null;

                const isBaseCell =
                  basePrice != null && category.isDefault && room.isDefault;

                return (
                  <td key={catIndex} className="py-3 px-4 whitespace-nowrap">
                    {priceIndex !== -1 ? (
                      <AccommodationPriceCell
                        categoryIndex={catIndex}
                        roomIndex={roomIndex}
                        priceIndex={priceIndex}
                        categoryFieldName={`accommodationCategories.${catIndex}`}
                        isBaseCell={isBaseCell}
                        basePrice={basePrice}
                        paxCount={room.paxCount}
                        isReadOnly={isReadOnly}
                      />
                    ) : (
                      <span className="text-sm text-gray-300 italic">—</span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
